import { MasterTranslation } from '@/constants';
import { useGlobalState, useStatsigLayer } from '@/hooks';

export const useWaitingTrackingInfoCopy = (): string => {
  const { t } = useGlobalState();
  const { getEnglishOnlyText, isReady } = useStatsigLayer('track_my_parcel_copy_layer');

  const fallback = t(MasterTranslation.WaitingTrackingInfo);

  if (!isReady) return fallback;

  return getEnglishOnlyText('waiting_tracking_info', fallback);
};
